import { render, staticRenderFns } from "./AssessmentTemplatePrinterExample.vue?vue&type=template&id=6f1b68aa"
import script from "./AssessmentTemplatePrinterExample.vue?vue&type=script&lang=js"
export * from "./AssessmentTemplatePrinterExample.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTemplatePrinterExample.vue?vue&type=style&index=0&id=6f1b68aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports